
<template>
  <div class="musicwowDetails">
    <Headers></Headers>
    <div class="musicwowDetails-center">
      <!-- <img :src="imgUrl"> -->
      <div class="center-body">
        <div class="body-title">
          <p>{{ listData.title }}</p>
        </div>
        <div class="items-image" v-html="listData.content"></div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "musicwowDetails",
  data() {
    return {
      navData: [],
      listData: [],
      imgUrl:
        "" || "https://aliyunosszs.musicwow.com/APPimg/product/musicBg.png",
    };
  },
  computed: {},
  components: {
    Headers,
    Footer,
  },
  methods: {
    async onMusicData() {
      let id = this.$route.params.id;
      this.$ajax
        .get("https://site.musicwow.com/api/v1/product/details/" + id)
        .then((res) => {
          // console.log(res)
          this.listData = res.data.data;
          this.imgUrl = res.data.data.banner[0].image;
          // console.log(this.listData)
        })
        .catch((res) => {
          // console.log(res);
        });
    },
  },
  mounted() {},
  created() {
    this.onMusicData();
  },
};
</script>
<style lang="sass" scoped>
.musicwowDetails
  .musicwowDetails-center
    padding-top: 60px
    img
      width: 100%
    .center-body
      text-align: left
      .body-title
        padding: 15px 0
        border-bottom: 1px solid #ccc
        font-size: 20px
        color: #333333
        p
          margin-left: 30px
      .items-image
        margin: 30px
      img
        width: 152px !important
        margin: auto
      // .items-image img:nth-child(2n)
      //   margin-left: auto
</style>

